export const imgUrl = 'https://d49qdhygt0dif.cloudfront.net';
export const url = import.meta.env.VITE_BASE_URL1;
export const editorUrl = import.meta.env.VITE_ADSIGN_EDITOR_URL;
